module.exports = __webpack_public_path__ + "img/avatar-defult.0ae37250.jpg";